import {User} from "v2/api/Records";

export const apiUser = (user) => {
  return new User(prepareUserData(user));
};

export const prepareUserData = (user) => {
  return {
    ...user,
    fullName: user.name,
  };
};

export default {
  apiUser,
  prepareUserData,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Users.js
 **/